import { createSlice } from '@reduxjs/toolkit';
import reducers from './reducers';
import extraReducers from './extraReducers';
import { DEFAULT_PRINT_FILE_JOBS_PARAMS } from './defaults';
import { IPrintFileLineItem, IPrintFileJobsQueryParams } from '../../../api/printFileJobs';

export * from '../../thunk/printFileJobs';
export { DEFAULT_PRINT_FILE_JOBS_PARAMS } from './defaults';

export interface IPrintFileJobsState {
    list: IPrintFileLineItem[];
    status: string | null;
    error: string | null;
    queryParams: IPrintFileJobsQueryParams;
}

const initialState: IPrintFileJobsState = {
    list: [],
    status: null,
    error: null,
    queryParams: DEFAULT_PRINT_FILE_JOBS_PARAMS(),
};

const PrintFileJobsSlice = createSlice({
    name: 'printFileJobs',
    initialState,
    reducers,
    extraReducers,
});

const { actions, reducer } = PrintFileJobsSlice;
export const { clearPrintFileJobsFilters, setPrintFileJobsQueryParams } = actions;
export { reducer };
